import { useMemo } from 'react';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import { useNavigate } from 'react-router-dom';
import { useProductStore, toRouteKey } from '@/store/product';
import img_pages_home_lanhu_5 from '@/assets/svg/pages-home-lanhu-5.svg';

function collectionListPath(item) {
  if (item.link) return item.link;
  const key = item.routeKey ?? toRouteKey(item.collection_name ?? item.title);
  return `/products/${key}`;
}

const Products = () => {
  const navigate = useNavigate();
  const collections = useProductStore(s => s.collections);
  const others = useProductStore(s => s.others);
  const showcaseItems = useMemo(() => [...collections, ...others], [collections, others]);
  const showcaseLabel = item => item.collection_name ?? item.title;

  return (
    <div className={styles['products-page']}>
      <div className={styles.page}>
        <section className={styles['products-hero']}>
          <div className={styles['products-hero__overlay']}>
            <SiteTopNav />
            <div className={styles['products-hero__content']}>
              <h1 className={styles['products-hero__title']} data-motion="hero">
                TIMELESS WOOD COLLECTIONS
              </h1>
              {/* <p className={styles['products-hero__lead']} data-motion="copy">
                The Autumn Collection and Winter Collection are crafted using Premium European White
                Oak, carefully selected for its stability, beautiful grain character, and consistent
                appearance. While the wood is sourced from Europe, every collection is developed
                according to Sakura Floors’ Japanese-inspired design philosophy, quality standards,
                and finishing techniques. This allows us to maintain reliable availability while
                delivering the refined look, performance, and craftsmanship our customers expect
                from Sakura Floors.
              </p> */}
            </div>
          </div>
        </section>

        <main className={styles['products-main']}>
          <h2 className={styles['products-main__title']} data-motion="title">
            Products
          </h2>

          <div className="fix-width relative">
            <section className={styles['products-collections']} aria-label="Product collections">
              {showcaseItems.map((item, idx) => (
                <article
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${showcaseLabel(item)}-${idx}`}
                  className={`${styles['product-feature']}${idx % 2 === 1 ? ` ${styles['product-feature--reversed']}` : ''}`}
                  data-motion="card"
                >
                  <div className={styles['product-feature__media']}>
                    <img
                      className={styles['product-feature__image']}
                      alt=""
                      referrerPolicy="no-referrer"
                      src={item.collection_poster ?? item.image}
                    />
                  </div>
                  <div className={styles['product-feature__body']}>
                    <h3 className={styles['product-feature__title']}>{showcaseLabel(item)}</h3>
                    <p className={styles['product-feature__desc']}>
                      {item.collection_desc ?? item.desc}
                    </p>
                    <button
                      className={styles['product-feature__cta']}
                      type="button"
                      onClick={() => navigate(collectionListPath(item))}
                      data-motion-interactive="press"
                    >
                      <span className={styles['product-feature__ctaLabel']}>view more</span>
                      <span className={styles['product-feature__ctaIcon']} aria-hidden="true">
                        <img
                          className={styles['product-feature__ctaArrow']}
                          alt=""
                          referrerPolicy="no-referrer"
                          src={img_pages_home_lanhu_5}
                        />
                      </span>
                    </button>
                  </div>
                </article>
              ))}
            </section>
          </div>

          <section
            className={styles['products-upcoming']}
            aria-label="Upcoming collection notice"
            data-motion="section"
          >
            <h2 className={styles['products-upcoming__title']} data-motion="title">
              THE SAKURA FLOORS DIFFERENCE
            </h2>
            <p className={styles['products-upcoming__text']} data-motion="copy">
              Autumn Collection and Winter Collection represent the next chapter of Sakura Floors.
              By combining Premium White Oak with Japanese-inspired craftsmanship and design, these
              collections offer exceptional stability, timeless aesthetics, and outstanding value.
              Designed for modern living while maintaining the warmth and elegance that define
              Sakura Floors, Autumn and Winter Collections are now available through authorized
              Sakura Floors dealers.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Products;
